module.exports = new __parcel__URL__("promotions-empty-view.d8dca90e.svg").toString();